import { C } from "./const";

const SectionTitle = ({
    children,
    center = false,
}: {
    children: React.ReactNode;
    center?: boolean;
}) => (
    <h2
        style={{
            fontSize: "clamp(24px, 4vw, 34px)",
            fontWeight: 800,
            color: C.primaryDark,
            marginBottom: 14,
            lineHeight: 1.4,
            textAlign: center ? "center" : "right",
        }}
    >
        {children}
    </h2>
);


export default SectionTitle;